import { lazyLoad } from '../../../utils/loadable'

export const ReactSyntaxHighlighter = lazyLoad(
  () => import('./SyntaxHighlighter'),
  component => component.default,
)
